import styled from 'styled-components';

export const ContainerOuter = styled.div`
    min-height: 100vh;
    background-size: 100%;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('/Assets/background_2.jpg');
    @media (min-width: 1000px) {
        background-size: 25%;
        background-repeat: repeat;
    }
`;

export const LoaderContainer = styled.div`
    min-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContainerInner = styled.div`
    width: 500px;
    padding: 30px 0;
    // padding: 30px 0 10px;
    border-radius: 5px;
    @media (max-width: 600px){
        width: 94%;
        margin: 0 15px;
    }
`;

export const DataContainer = styled.div`
    padding: 1px;
    background: #fff;
    border-radius: 5px;
    margin: 0;
    @media (max-width: 750px){
        padding: 1px;
    }
`;